import { useState, useEffect } from 'react';
import { useAuthFetch } from '../hooks/useAuthFetch';
import { useIsMobile } from '../hooks/useIsMobile';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : '—';
const Field = ({ label, value }) => (
  <div style={{ marginBottom: 12 }}>
    <div style={{ fontSize: 11, color: '#64748b', marginBottom: 2, fontWeight: 500, textTransform: 'uppercase' }}>{label}</div>
    <div style={{ fontSize: 13, color: '#e2e8f0' }}>{value || '—'}</div>
  </div>
);

export default function ContactPanel({ contactId, onClose }) {
  const fetchWithAuth = useAuthFetch();
  const isMobile = useIsMobile();
  const [contact, setContact] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchWithAuth(`/api/contacts/${contactId}`).then(r => r.json()).then(d => { setContact(d); setForm(d); setLoading(false); });
  }, [contactId]);

  const save = async () => {
    setSaving(true);
    const res = await fetchWithAuth(`/api/contacts/${contactId}`, { method: 'PUT', body: JSON.stringify(form) });
    const updated = await res.json();
    setContact(updated); setEditing(false); setSaving(false);
  };

  const del = async () => {
    if (!window.confirm('Supprimer ce contact ?')) return;
    await fetchWithAuth(`/api/contacts/${contactId}`, { method: 'DELETE' });
    onClose();
  };

  const inputStyle = { width: '100%', padding: '8px 10px', borderRadius: 6, background: '#0f1117', border: '1px solid #2a2d3e', color: '#e2e8f0', fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box' };

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99 }} />
      <div style={{ position: 'fixed', top: 0, right: 0, width: isMobile ? '100vw' : 400, height: '100vh', background: '#1a1d2e', borderLeft: '1px solid #2a2d3e', zIndex: 100, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ padding: '20px 20px 16px', borderBottom: '1px solid #2a2d3e', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontSize: 17, fontWeight: 700, color: '#e2e8f0' }}>{loading ? '...' : `${contact?.prenom || ''} ${contact?.nom || ''}`}</div>
            {contact?.principal ? <span style={{ fontSize: 11, color: '#f59e0b' }}>⭐ Contact principal</span> : null}
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: 20 }}>
          {loading ? <div style={{ color: '#64748b' }}>Chargement...</div> : !editing ? (
            <>
              {contact?.client_nom && (
                <div style={{ background: '#41B07315', border: '1px solid #41B07330', borderRadius: 8, padding: '8px 12px', marginBottom: 16, fontSize: 13, color: '#94a3b8' }}>
                  🏢 <span style={{ color: '#e2e8f0' }}>{contact.client_nom}</span>
                </div>
              )}
              <Field label="Poste" value={contact.poste} />
              <Field label="Email" value={contact.email} />
              <Field label="Téléphone" value={contact.telephone} />
              <Field label="Mobile" value={contact.mobile} />
              <Field label="Notes" value={contact.notes} />
              <Field label="Ajouté le" value={fmtDate(contact.created_at)} />
              <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                <button onClick={() => setEditing(true)} style={{ padding: '8px 16px', borderRadius: 8, background: '#41B073', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}>✏️ Modifier</button>
                <button onClick={del} style={{ padding: '8px 16px', borderRadius: 8, background: 'transparent', border: '1px solid #ef444440', color: '#ef4444', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}>🗑 Supprimer</button>
              </div>
            </>
          ) : (
            <div>
              {[['prenom', 'Prénom'], ['nom', 'Nom'], ['poste', 'Poste'], ['email', 'Email'], ['telephone', 'Téléphone'], ['mobile', 'Mobile']].map(([k, l]) => (
                <div key={k} style={{ marginBottom: 12 }}>
                  <label style={{ display: 'block', fontSize: 11, color: '#64748b', marginBottom: 4, textTransform: 'uppercase' }}>{l}</label>
                  <input value={form[k] || ''} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} style={inputStyle} />
                </div>
              ))}
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 11, color: '#64748b', marginBottom: 4, textTransform: 'uppercase' }}>Contact principal</label>
                <select value={form.principal || 0} onChange={e => setForm(f => ({ ...f, principal: Number(e.target.value) }))} style={inputStyle}>
                  <option value={0}>Non</option>
                  <option value={1}>Oui</option>
                </select>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 11, color: '#64748b', marginBottom: 4, textTransform: 'uppercase' }}>Notes</label>
                <textarea value={form.notes || ''} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} style={{ ...inputStyle, height: 70, resize: 'vertical' }} />
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={save} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, background: '#41B073', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}>{saving ? 'Enregistrement...' : '💾 Enregistrer'}</button>
                <button onClick={() => { setEditing(false); setForm(contact); }} style={{ padding: '8px 16px', borderRadius: 8, background: 'transparent', border: '1px solid #2a2d3e', color: '#94a3b8', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}>Annuler</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
